var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2342_27857)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 48,
    height: 48,
    rx: 10,
    fill: "#E8EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5026 27.5001C31.9118 27.504 31.3291 27.6388 30.7966 27.8947C30.2641 28.1506 29.7948 28.5213 29.4226 28.9801L24.3226 26.6301C24.5624 25.8959 24.5624 25.1044 24.3226 24.3701L29.4226 22.0201C30.0242 22.7461 30.8629 23.2362 31.7907 23.404C32.7185 23.5717 33.6758 23.4063 34.4935 22.937C35.3113 22.4677 35.937 21.7246 36.2601 20.8389C36.5833 19.9531 36.5832 18.9817 36.2599 18.096C35.9366 17.2103 35.3107 16.4674 34.4929 15.9982C33.6751 15.529 32.7178 15.3638 31.79 15.5317C30.8622 15.6997 30.0236 16.1899 29.4221 16.916C28.8206 17.6421 28.495 18.5573 28.5026 19.5001C28.5056 19.7383 28.529 19.9759 28.5726 20.2101L23.2926 22.6401C22.7297 22.0897 22.0168 21.7176 21.2434 21.5705C20.47 21.4235 19.6703 21.5079 18.9446 21.8132C18.219 22.1186 17.5996 22.6313 17.164 23.2872C16.7284 23.943 16.4961 24.7128 16.4961 25.5001C16.4961 26.2874 16.7284 27.0572 17.164 27.7131C17.5996 28.3689 18.219 28.8816 18.9446 29.187C19.6703 29.4923 20.47 29.5768 21.2434 29.4297C22.0168 29.2826 22.7297 28.9105 23.2926 28.3601L28.5726 30.7901C28.529 31.0243 28.5056 31.2619 28.5026 31.5001C28.5026 32.2912 28.7372 33.0646 29.1767 33.7224C29.6162 34.3802 30.241 34.8929 30.9719 35.1956C31.7028 35.4984 32.507 35.5776 33.283 35.4233C34.0589 35.2689 34.7716 34.8879 35.331 34.3285C35.8904 33.7691 36.2714 33.0564 36.4257 32.2805C36.5801 31.5045 36.5009 30.7003 36.1981 29.9694C35.8954 29.2385 35.3827 28.6138 34.7249 28.1742C34.0671 27.7347 33.2937 27.5001 32.5026 27.5001ZM32.5026 17.5001C32.8982 17.5001 33.2848 17.6174 33.6137 17.8372C33.9426 18.0569 34.199 18.3693 34.3504 18.7347C34.5017 19.1002 34.5413 19.5023 34.4642 19.8903C34.387 20.2783 34.1965 20.6346 33.9168 20.9143C33.6371 21.194 33.2807 21.3845 32.8928 21.4617C32.5048 21.5389 32.1027 21.4992 31.7372 21.3479C31.3718 21.1965 31.0594 20.9402 30.8397 20.6113C30.6199 20.2824 30.5026 19.8957 30.5026 19.5001C30.5026 18.9697 30.7133 18.461 31.0884 18.0859C31.4635 17.7108 31.9722 17.5001 32.5026 17.5001ZM20.5026 27.5001C20.107 27.5001 19.7203 27.3828 19.3915 27.1631C19.0626 26.9433 18.8062 26.6309 18.6548 26.2655C18.5035 25.9 18.4639 25.4979 18.541 25.1099C18.6182 24.722 18.8087 24.3656 19.0884 24.0859C19.3681 23.8062 19.7244 23.6157 20.1124 23.5385C20.5004 23.4614 20.9025 23.501 21.268 23.6524C21.6334 23.8037 21.9458 24.0601 22.1655 24.389C22.3853 24.7179 22.5026 25.1046 22.5026 25.5001C22.5026 26.0305 22.2919 26.5393 21.9168 26.9143C21.5417 27.2894 21.033 27.5001 20.5026 27.5001ZM32.5026 33.5001C32.107 33.5001 31.7203 33.3828 31.3915 33.1631C31.0626 32.9433 30.8062 32.6309 30.6548 32.2655C30.5035 31.9 30.4639 31.4979 30.541 31.1099C30.6182 30.722 30.8087 30.3656 31.0884 30.0859C31.3681 29.8062 31.7244 29.6157 32.1124 29.5385C32.5004 29.4614 32.9025 29.501 33.268 29.6524C33.6334 29.8037 33.9458 30.0601 34.1655 30.389C34.3853 30.7179 34.5026 31.1046 34.5026 31.5001C34.5026 32.0305 34.2919 32.5393 33.9168 32.9143C33.5417 33.2894 33.033 33.5001 32.5026 33.5001Z",
    fill: "#2948A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2342_27857",
    x: 0.5,
    y: 0.5,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2342_27857"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2342_27857",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareSquare);
export default __webpack_public_path__ + "static/media/shareSquare.0b60824e2c00d767aecf540b9b13b62a.svg";
export { ForwardRef as ReactComponent };